import { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../../ui/Footer/Footer";
import image1 from "./img/image1.svg";
import image2 from "./img/Vector.svg";
import image3 from "./img/Vector (1).svg";
import image4 from "./img/Group 427319204.svg";
import web from "./img/web.svg";
import Industry from "./img/Industry.svg";
import Enhanced from "./img/Enhanced.svg";
import RealTime from "./img/bytesize_lightning.svg";
import increased from "./img/Increased.svg";
import cost from "./img/Cost.svg";
import better from "./img/Better.svg";
import "./home.css";
export const HomePage = () => {
  const toolsData = [
    {
      title: "1. 3D & 2D MODEL VIEWING",
      text: " Advanced visualization tools for comprehensive model exploration. Navigate complex construction models directly in your browser with seamless 2D/3D switching, ensuring you always have the right perspective.",
      points: [
        "Seamless switching between 2D and 3D environments",
        "Precise measurement tools for distances, areas, and volumes",
        "No software installation or heavy hardware required",
      ],
      image: image1,
    },
    {
      title: "2. VERSION COMPARISON",
      text: "dentify changes between model versions instantly. viewStruct's comparison tool allows you to accurately overlay architectural and engineering models, helping your team identify clashes early and prevent costly on-site errors.",
      points: [
        "Instant visual detection of added, removed, or modified elements",
        "Accurate overlay for multidisciplinary models",
        "Early clash identification before construction begins",
      ],
      image: image1,
    },
    {
      title: "3. COLLABORATIVE TOOLS",
      text: "Work together with your team in a unified environment. Streamline communication by creating issues and adding comments directly to the model, and easily share projects with external stakeholders.",
      points: [
        "Flexible access control (Admin, Contributor, and Viewer roles)",
        "Real-time issue tracking and contextual comments",
        "Account-free sharing for clients and external consultants",
      ],
      image: image1,
    },
    {
      title: "4. DETAILED ANALYTICS",
      text: "Turn your construction models into a reliable source of business data. Extract project specifications, analyze volumes, and track your team's workflow progress through intuitive interactive dashboards.",
      points: [
        "Automated data extraction and quantity takeoffs",
        "Interactive dashboards for tracking team activity and issues",
        "One-click data export to PDF and Excel formats",
      ],
      image: image1,
    },
  ];
  const faqData = [
    {
      question: "What file formats are supported?",
      answer:
        "IFC, RVT, DWG, DAE, GLTF, GLB, STEP, STL and many other popular CAD/BIM formats with automatic conversion.",
    },
    {
      question: "Do you offer team plans?",
      answer:
        "Yes, we offer flexible team plans with role-based access for Admins, Contributors, and Viewers.",
    },
    {
      question: "Can I try viewStruct for free?",
      answer:
        "Yes, we offer a free trial so you can explore the platform before committing.",
    },
    {
      question: "How fast is support response?",
      answer: "Our support team typically responds within 24 hours.",
    },
    {
      question: "Is my data secure?",
      answer:
        "Yes, we use enterprise-grade encryption for data transmission and storage.",
    },
    {
      question: "How do I report a bug?",
      answer:
        "You can report bugs directly through the in-app issue tracker or by contacting support.",
    },
  ];

  const [openFaq, setOpenFaq] = useState(0);
  const [toolIndex, setToolIndex] = useState(0);

  const toggleFaq = (idx) => {
    setOpenFaq((prev) => (prev === idx ? -1 : idx));
  };

  const prevTool = () =>
    setToolIndex((i) => (i === 0 ? toolsData.length - 1 : i - 1));
  const nextTool = () =>
    setToolIndex((i) => (i === toolsData.length - 1 ? 0 : i + 1));

  const activeTool = toolsData[toolIndex];
  return (
    <>
      <section class="hero">
        <img
          class="hero-bg"
          src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1800&q=85"
          alt="Construction site under a crane"
        />
        <div class="hero-overlay"></div>

        <div class="container hero-content">
          <h2 class="hero-eyebrow">Visualize &amp; Compare</h2>
          <h1>3D Construction Models</h1>
          <p class="hero-sub">
            Professional browser-based 3D and 2D model viewer designed for
            construction companies. Compare versions, analyze changes, and
            collaborate seamlessly with industry-standard tools.
          </p>

          <ul class="hero-points">
            <li>No software installation</li>
            <li>Industry standards</li>
            <li>Secure cloud platform</li>
          </ul>

          <Link
            to="https://www.youtube.com/watch?v=Q1HHlLMr-q0"
            class="btn btn-light demo-btn btn-one"
            target="_blank"
          >
            ▶&nbsp; WATCH DEMO
          </Link>
        </div>
      </section>

      <section class="section tools-section" id="features">
        <div class="container two-col tools-grid">
          <div class="tools-left">
            <p class="eyebrow">FEATURES \</p>
            <h2>
              Professional
              <br />
              Construction Tools
            </h2>
            <p class="body-text">
              Advanced visualization and collaboration platform designed for
              modern construction workflows.
            </p>
            <Link
              to="HelpCenter/category/getting-started"
              class="btn btn-dark btn-two"
            >
              EXPLORE MORE
            </Link>
          </div>

          <div class="tools-right">
            <img
              src={activeTool.image}
              alt={activeTool.title}
              class="tools-image"
            />

            <div class="tools-list">
              <h2 class="tools-list-title">{activeTool.title}</h2>
              <p class="tools-copy">{activeTool.text}</p>
              <ul class="tools-points">
                {activeTool.points.map((point, idx) => (
                  <li key={idx}>{point}</li>
                ))}
              </ul>
              <div class="slider-arrows">
                <span onClick={prevTool} style={{ cursor: "pointer" }}>
                  ←
                </span>
                <span onClick={nextTool} style={{ cursor: "pointer" }}>
                  →
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section advantages-section" id="benefits">
        <div class="container">
          <p class="eyebrow eye">WHY CHOOSE US \</p>
          <h2>Key Advantages</h2>

          <div class="two-col advantages-row">
            <ul class="advantages-list">
              <li>
                <span class="adv-icon">
                  <img src={web} alt="Web" />
                </span>
                <div>
                  <h4>Browser-Based</h4>
                  <p>
                    No software installation required. Access powerful 3D
                    visualization directly in your browser.
                  </p>
                </div>
              </li>
              <li>
                <span class="adv-icon">
                  <img src={Industry} alt="Industry" />
                </span>
                <div>
                  <h4>Industry Standards</h4>
                  <p>
                    Full support for IFC, DWG, RVT, and other construction
                    industry standard formats.
                  </p>
                </div>
              </li>
              <li>
                <span class="adv-icon">
                  <img src={Enhanced} alt="Enhanced Security" />
                </span>
                <div>
                  <h4>Enhanced Security</h4>
                  <p>
                    Enterprise-grade security with encrypted data transmission
                    and secure cloud storage.
                  </p>
                </div>
              </li>
              <li>
                <span class="adv-icon">
                  <img src={RealTime} alt="Real-time Updates" />
                </span>
                <div>
                  <h4>Real-time Updates</h4>
                  <p>
                    Instant synchronization and live collaboration features for
                    seamless teamwork.
                  </p>
                </div>
              </li>
            </ul>

            <div class="advantages-image">
              <div class="dashboard">
                <img src={image4} alt="Dashboard" srcset="" />
              </div>
            </div>
          </div>

          <div class="stats-row">
            <div class="stat-card">
              <span class="stat-icon">
                <img src={increased} alt="Increased Productivity" />
              </span>
              <p class="stat-label">Increased Productivity</p>
              <p class="stat-value">
                40%<span>faster</span>
              </p>
              <p class="stat-desc">
                Teams complete reviews and approvals in a fraction of the time.
              </p>
            </div>
            <div class="stat-card">
              <span class="stat-icon">
                <img src={cost} alt="Cost Reduction" />
              </span>
              <p class="stat-label">Cost Reduction</p>
              <p class="stat-value">
                60%<span>savings</span>
              </p>
              <p class="stat-desc">
                Eliminate software licensing costs and reduce infrastructure
                expenses.
              </p>
            </div>
            <div class="stat-card">
              <span class="stat-icon">
                <img src={better} alt="Better Collaboration" />
              </span>
              <p class="stat-label">Better Collaboration</p>
              <p class="stat-value">
                3x<span>faster</span>
              </p>
              <p class="stat-desc">
                Eliminate software licensing costs and reduce infrastructure
                expenses.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section reach-section">
        <div class="container reach-container">
          <p class="eyebrow eyebrow-light">RESULTS \</p>

          <div class="reach-panel">
            <div class="reach-grid">
              <div class="reach-cell reach-image">
                <img
                  src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=700&q=85"
                  alt="World map"
                />
              </div>
              <div class="reach-cell reach-stat">
                <p class="reach-value">2M+</p>
                <p class="reach-label">PROJECTS</p>
              </div>
              <div class="reach-cell reach-image">
                <img
                  src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=700&q=85"
                  alt="Team reviewing plans"
                />
              </div>
              <div class="reach-cell reach-stat">
                <p class="reach-value">150+</p>
                <p class="reach-label">COUNTRIES</p>
              </div>
              <div class="reach-cell reach-image">
                <img
                  src="https://images.unsplash.com/photo-1503387837-b154d5074bd2?w=700&q=85"
                  alt="Engineer at a workstation"
                />
              </div>
              <div class="reach-cell reach-stat">
                <p class="reach-value">99.9+</p>
                <p class="reach-label">UPTIME</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section tour-faq-section" id="tour">
        <div class="container">
          <div class="two-col tour-row">
            <div class="tour-left">
              <p class="eyebrow">PRODUCT IN ACTION \</p>
              <h2>
                Quick tour of our
                <br />
                platform
              </h2>
              <p class="body-text">
                Discover how viewStruct transforms heavy construction data into
                lightweight, accessible insights. Whether you are in the office
                or on the construction site, get instant access to precise
                measurements, clash detection, and team communications in
                seconds.
              </p>
              <a
                href="https://www.youtube.com/watch?v=Q1HHlLMr-q0"
                class="btn btn-dark btn-two"
                target="_blank"
              >
                EXPLORE MORE
              </a>
            </div>

            <div class="tour-right">
              <div class="video-thumb">
                <iframe
                  width="600"
                  height="400"
                  src="https://www.youtube.com/embed/Q1HHlLMr-q0?si=UnF8fFCcRTMoiBBo"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>

          <div class="two-col faq-row">
            <div class="faq-left">
              <h2>
                Frequently Asked
                <br />
                Questions
              </h2>
            </div>

            <div class="faq-right">
              <ul class="faq-list">
                {faqData.map((item, idx) => (
                  <li
                    key={idx}
                    class={openFaq === idx ? "faq-item faq-open" : "faq-item"}
                    onClick={() => toggleFaq(idx)}
                  >
                    <div class="faq-item-header">
                      <span class="faq-question">{item.question}</span>
                      <span className="chev">
                        {openFaq === idx ? (
                          <img src={image2} alt="Up arrow" />
                        ) : (
                          <img src={image3} alt="Down arrow" />
                        )}
                      </span>
                    </div>
                    <div
                      class="faq-answer-wrapper"
                      style={{
                        maxHeight: openFaq === idx ? "200px" : "0px",
                      }}
                    >
                      <p>{item.answer}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="section cta-section" id="contact">
        <div class="container cta-inner">
          <h2>
            Ready to revolutionize your
            <br />
            construction projects?
          </h2>
          <p>
            Join thousands of construction professionals who trust viewStruct
            with their visualization.
          </p>

          <Link to="/Contact" class="btn btn-light">
            CONTACT US
          </Link>
        </div>
      </section>

      <Footer />
    </>
  );
};
